import React from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import Card from '../Card/Card';
import './TariffItem.less';
import {
  getBrandColor,
  getLightBrandColor,
  LocalizePropType,
} from 'getaway-data-layer';
import Hyperlink from 'react-native-hyperlink';

type Props = {
  title: string;
  subTitle?: string;
  price: string;
  description: string;
  deductionTitle?: string;
  deductionPrice?: string;
  selected: boolean;
  onClick: () => void;
  localize: LocalizePropType;
  showExtraOptionsLink?: boolean;
  onClickExtraOptions?: () => void;
  firstItem?: boolean;
  lastItem?: boolean;
  subTitleClassName?: string;
  showPopularBadge?: boolean;
  popularText?: string;
  tariffTestId?: string;
  hideRadio?: boolean;
  tariffHeaderImage?: any;
  tariffHeaderLogo?: any;
};

const TariffItem = ({
  tariffTestId,
  localize,
  title,
  subTitle,
  price,
  description,
  selected,
  onClick,
  showExtraOptionsLink,
  onClickExtraOptions,
  firstItem,
  lastItem,
  subTitleClassName,
  showPopularBadge,
  popularText,
  hideRadio,
  tariffHeaderImage,
  tariffHeaderLogo,
}: Props) => {
  return (
    <Card hideShadow={true} firstItem={firstItem} lastItem={lastItem}>
      {tariffHeaderImage && (
        <img className="tariff-header-image" src={tariffHeaderImage} />
      )}
      <div
        data-testid={tariffTestId}
        className="tariff-container"
        onClick={onClick}
        style={selected ? { backgroundColor: getLightBrandColor() } : {}}
      >
        {tariffHeaderLogo && (
          <img className="tariff-header-logo" src={tariffHeaderLogo} />
        )}
        <div className="tariff-title-container">
          <strong className="tariff-title">{title}</strong>
          {showPopularBadge && (
            <div className={`tariff-badge-popular`}>{popularText}</div>
          )}
        </div>

        {subTitle && (
          <Markdown
            rehypePlugins={[rehypeRaw]}
            className={`tariff-subtitle ${subTitleClassName}`}
          >
            {subTitle}
          </Markdown>
        )}

        {!showExtraOptionsLink && description && (
          <Markdown rehypePlugins={[rehypeRaw]} className="tariff-desc">
            {description}
          </Markdown>
        )}
        {showExtraOptionsLink && (
          <div className="tariff-desc">
            <Hyperlink
              linkStyle={{ color: getBrandColor() }}
              linkText={(url) => {
                if (url === localize('signup.terms.url')) {
                  return localize('tariff.extra.options.link');
                }
                return url;
              }}
              onPress={() => {
                onClickExtraOptions();
              }}
            >
              <pre>
                {localize(
                  'tariff.Rahmentarif.desc.new',
                  localize('signup.terms.url')
                )}
              </pre>
            </Hyperlink>
          </div>
        )}
        {!hideRadio && (
          <div className="tariff-radio-wrapper">
            <div className="tariff-price">
              <Markdown rehypePlugins={[rehypeRaw]}>{price}</Markdown>
            </div>
            <input
              type="radio"
              id="radioButton"
              name="radioGroup"
              className="tariff-radio"
              checked={selected}
            />
          </div>
        )}
      </div>
    </Card>
  );
};

TariffItem.defaultProps = {
  subTitleClassName: '',
  showPopularBadge: false,
  tariffTestId: 'tariffView-contanier',
  hideRadio: false,
};

export default TariffItem;
